<template>
    <div class="container-fluid">
        <div class="herosection">
            <NavbarSection />
        </div>
        <div class="img-container">
            <div class="heroWriteup">
                <h2>{{dataList.name}}</h2>
                <p v-html="dataList.title"></p>
            </div>
            <div class="imgsection">
                <template v-if="dataList.banner && isImage(dataList.banner)">
                    <img :src="base_url + dataList.banner" alt="">
                </template>

                <template v-else-if="dataList.banner && isVideo(dataList.banner)">
                    <video :src="base_url + dataList.banner" controls></video>
                </template>

                <template v-else>
                    <span>No media</span>
                </template>
            </div>

            <div class="p-5 mt-3" style="text-align: left;" v-html="dataList.description">
           
            </div>
        </div>
     
    
    <FooterSection />
</div>
</template>

<script setup>
import FooterSection from '@/components/FooterSection.vue';
import NavbarSection from '@/components/NavbarSection.vue';
import { ref, onMounted } from "vue"
import axios from 'axios';
//import router from "@/router";
import { useRoute } from 'vue-router'

const route = useRoute()

const dataList = ref([]);
const dataId = ref('')
let base_url = process.env.VUE_APP_BASE_LIVE_URL

onMounted( async () => {
  dataId.value = route.params.title
  console.log(dataId.value)
  await listRecords();
});


// Fetch records
const isImage = (file) => {
        return /\.(jpg|jpeg|png|gif|webp)$/i.test(file);
    }
const isVideo = (file) => {
    return /\.(mp4|mov|avi|mkv|webm)$/i.test(file);
}
const listRecords = async () => {
  try {
    const response = await axios.get(`/sport_section_detail.php?id=${dataId.value}`);
    dataList.value = response.data.data
  } catch (error) {
    console.error(error.message);
  }
};

</script>

<style lang="scss" scoped>
.herosection {
    border-radius: 20px;
    background: #ffffff;
    background-size: cover;
    height: 105px;
    padding: 10px;
    position: relative;
    width: 100%;
    overflow: hidden;
    padding:1.5rem 4rem 4rem 4rem;
}
.img-container{
    display: flex;
    flex-direction: column;
    align-items: center;
}

.heroWriteup {
    display: flex;
    flex-direction: column;
    color: #000;
   // margin: 4rem 0 4rem 0;

    h2 {
        font-size: 45px;
        font-weight: 700;
        font-family: "Open Runde", sans-serif;
        text-align: center;
    }

    p {
        font-size: 16px;
        font-weight: 500;
        font-family: "Open Runde", sans-serif;
        text-align: center;
        width: 80%;
        margin: 0 auto;          /* centers the <p> within its parent */
        word-wrap: break-word;   /* ensures long words wrap */
        overflow-wrap: break-word; /* modern equivalent */
        white-space: normal;     /* ensures wrapping happens */
    }
}
.imgsection{
    width: 90%;
    img{
        width: 100%;
        height: 540px;
        opacity: 1;
        border-radius: 20px;
        border-width: 3px;

    }
    video{
        width: 100%;
        //height: 540px;
        opacity: 1;
        border-radius: 10px;
        border-width: 3px;

    }
}
@media (max-width: 768px) {

    
    .imgsection{
        margin-top: 20px;

        img{
        width: 100%;
        height: 540px;
        opacity: 1;
        border-radius: 20px;
        border-width: 3px;
       }
       video{
        width: 100%;
        //height: 540px;
        opacity: 1;
        border-radius: 10px;
        border-width: 3px;
      }
    }
}
.container{
    max-width: 1220px;
}

.event-card {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 90%;
}

.blog-content{
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 20px;
    opacity: 1;
    padding: 0 50px 0 0;


    h4{
        text-align: left;
        width: 100%;
        margin: 0 auto;          /* centers the <p> within its parent */
        word-wrap: break-word;   /* ensures long words wrap */
        overflow-wrap: break-word; /* modern equivalent */
        white-space: normal; 
    }
    p{
        text-align: left;
        width: 100%;
        margin: 0 auto;          /* centers the <p> within its parent */
        word-wrap: break-word;   /* ensures long words wrap */
        overflow-wrap: break-word; /* modern equivalent */
        white-space: normal; 
        
    }
}
.blog-img img{
    width: 534px;
    height: 303px;
    opacity: 1;
    border-radius: 10px;
}
.accordion-list {
    width: 100%;
    padding-top: 60px;
    padding-right: 80px;
    padding-bottom: 0px;
    padding-left: 80px;
    opacity: 1;
    border-radius: 40px;
    border-width: 1px;
}

.policy-title{
    font-size: 20px;
    line-height: 100%;
    text-align: left;
    margin-bottom: 50px;
}
.question-content{
    text-align: left;
}
.accordion-item {
    border-bottom: 1px solid #00000040;
    padding: 12px 0;
}

.accordion-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    background: none;
    border: none;
    padding: 0;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    text-align: left;
}

.accordion-title {
    flex: 1;
    font-weight: 500;
    font-family: "Open Runde", sans-serif;
    color: #000000;
    font-size: 18px;
}

.accordion-icon {
    width: 30px;
    height: 30px;
    transition: transform 0.2s ease;
}

.accordion-icon.rotated {
    transform: rotate(180deg);
}

.accordion-content {
    margin-top: 8px;
    font-size: 14px;
    line-height: 1.6;
    color: #333;
    text-align: left;
}

/* Smooth open/close transition */
.accordion-enter-active,
.accordion-leave-active {
    transition: max-height 0.25s ease, opacity 0.2s ease;
}

.accordion-enter-from,
.accordion-leave-to {
    max-height: 0;
    opacity: 0;
}

.accordion-enter-to,
.accordion-leave-from {
    max-height: 200px;
    opacity: 1;
}

@media (max-width: 768px) {
    .herosection {
        border-radius: 20px;
        background-image: url('../assets/images/HeroBg.png');
        background-size: cover;
        height: 624px;
        padding: 10px;
        position: relative;
        width: 100%;

    }

    .overlay-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        /* make it cover */
        height: 100%;
        object-fit: cover;
        /* prevent distortion */
        opacity: 0.6;
        /* control transparency */
    }



    .heroWriteup {
        position: absolute;
        width: 100%;
        text-align: left;
        top: 40%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        gap: 10px;
        justify-content: center;
        align-items: center;
        color: white;

        h2 {
            font-size: 28px;
            font-weight: 700;
            font-family: "Open Runde", sans-serif;
            text-align: center;
        }

        p {
            font-size: 14px;
            font-weight: 500;
            font-family: "Open Runde", sans-serif;
            text-align: center;

        }

        .register {
            background-color: #ed4e24;
            border: 2px solid #7c7777;
            color: white;
            border-radius: 30px;
            font-family: "Open Runde", sans-serif;
            font-size: 16px;
            padding: 15px 25px;
            cursor: pointer;
            transition: 0.3s ease;
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 10px;
        }
    }
}

.card {
    max-width: 100%;
    margin: 1rem auto;
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    background-color: #ffffff;
    border-radius: 40px;
    border: 1px solid #00000033;
    padding: 10px 20px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
</style>
